var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pdf-viewer',{attrs:{"pdfUrl":_vm.samplePdf}})}
var staticRenderFns = []

export { render, staticRenderFns }